import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { exchanger, wallet } from '../services/api';
import { useStore } from '../store';
import { useTheme, useAppStyles } from '../theme';


// Shown to new users who have 0 TXC balance
// Guides them to buy TXC before using the app
export default function OnboardingScreen() {
  const C = useTheme();
  const styles = useAppStyles();
  const nav = useNavigate();
  const { user, balance } = useStore();
  const [step, setStep] = useState(1);

  const name = user?.username || user?.email?.split('@')[0] || 'there';

  return (
    <div style={{
      maxWidth:430, margin:'0 auto',  background:C.bg,
      display:'flex', flexDirection:'column',
      padding:'40px 24px', color:C.text
    }}>

      {step === 1 && (
        <div style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',textAlign:'center'}}>
          <img src="/vgo-logo.png" alt="VGO" style={{width:80,height:80,objectFit:'contain',marginBottom:24,filter:'drop-shadow(0 4px 16px #6366f155)'}} />

          <div style={{fontSize:26,fontWeight:900,marginBottom:8}}>
            Welcome, {name.charAt(0).toUpperCase()+name.slice(1)}! 👋
          </div>
          <div style={{fontSize:15,color:C.muted,marginBottom:40,lineHeight:1.7}}>
            You're now part of the VGO ecosystem.<br/>
            Your wallet is ready. Let's get your first TXC.
          </div>

          {/* What is TXC */}
          <div style={{
            background:C.card, border:`1px solid ${C.border}`,
            borderRadius:20, padding:24, marginBottom:20,
            width:'100%', textAlign:'left'
          }}>
            <div style={{fontSize:14,fontWeight:700,marginBottom:12,color:C.primary}}>
              What is TXC?
            </div>
            {[
              ['💳','Only currency in VGO ecosystem'],
              ['⚡','T+0 instant settlement worldwide'],
              ['🌍','Send to anyone via username@vgo'],
              ['📈','Trade VGO stocks (VTEC, VMKT...)'],
              ['🎯','Earn by playing MindStake quizzes'],
            ].map(([icon,text])=>(
              <div key={text} style={{display:'flex',gap:12,alignItems:'center',marginBottom:10}}>
                <span style={{fontSize:18}}>{icon}</span>
                <span style={{fontSize:13,color:C.muted}}>{text}</span>
              </div>
            ))}
          </div>

          <button onClick={()=>setStep(2)} style={{
            width:'100%', padding:'16px',
            background:`linear-gradient(135deg,${C.green},#059669)`,
            border:'none', borderRadius:14,
            color:'#fff', fontSize:16, fontWeight:700, cursor:'pointer'
          }}>
            Get My First TXC →
          </button>

          <button onClick={()=>nav('/home')} style={{
            background:'none', border:'none',
            color:C.muted, fontSize:13,
            marginTop:16, cursor:'pointer'
          }}>
            Skip for now
          </button>
        </div>
      )}

      {step === 2 && (
        <div>
          <button onClick={()=>setStep(1)} style={{
            background:C.input, border:'none', color:C.text,
            borderRadius:12, width:40, height:40,
            cursor:'pointer', fontSize:18, marginBottom:24
          }}>←</button>

          <div style={{fontSize:22,fontWeight:900,marginBottom:6}}>Buy TXC</div>
          <div style={{fontSize:13,color:C.muted,marginBottom:24}}>
            Pay with UPI, bank transfer or any local method
          </div>

          {/* How it works */}
          <div style={{
            background:C.card, border:`1px solid ${C.green}33`,
            borderRadius:16, padding:20, marginBottom:24
          }}>
            <div style={{fontSize:13,color:C.green,fontWeight:600,marginBottom:12}}>
              How inbound works:
            </div>
            {[
              ['1','Enter TXC amount you want'],
              ['2','Get local exchanger\'s UPI/bank details'],
              ['3','Send money from your bank app'],
              ['4','Exchanger confirms → TXC in your wallet instantly'],
            ].map(([n,t])=>(
              <div key={n} style={{display:'flex',gap:12,marginBottom:8}}>
                <div style={{
                  width:22,height:22,borderRadius:'50%',
                  background:C.green+'22',color:C.green,
                  display:'flex',alignItems:'center',justifyContent:'center',
                  fontSize:11,fontWeight:700,flexShrink:0
                }}>{n}</div>
                <span style={{fontSize:13,color:C.muted}}>{t}</span>
              </div>
            ))}
          </div>

          <button onClick={()=>nav('/inbound')} style={{
            width:'100%', padding:'16px',
            background:`linear-gradient(135deg,${C.green},#059669)`,
            border:'none', borderRadius:14,
            color:'#fff', fontSize:16, fontWeight:700, cursor:'pointer',
            marginBottom:12
          }}>
            Buy TXC Now
          </button>

          <button onClick={()=>nav('/home')} style={{
            width:'100%', padding:'14px',
            background:C.card, border:`1px solid ${C.border}`,
            borderRadius:14, color:C.muted,
            fontSize:14, cursor:'pointer'
          }}>
            I'll buy TXC later
          </button>
        </div>
      )}
    </div>
  );
}
